module.exports = __webpack_public_path__ + "img/电商小包模式.46d52e4a.png";